import React from "react"
import './calendar.scss'
import { Link } from 'react-router-dom'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
import MiniLoading from '../../components/miniloading/miniloading'

export default class Calendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            days: [],
            loading: false
        };

        this.addEventsDay = (arrayDays, currentMonth, events) => {
            this.setState({ loading: true })
            var ArrayEventFake = []

            const cache = JSON.parse(sessionStorage.getItem('OITO'))
            if (cache) {
                const client = new GraphQLClient(endpoint, {
                    headers: {
                        Authorization: `Bearer ${cache.token}`,
                    },
                })

                // client.request(`
                // {
                //     allProposes(filter: {
                //       OR: [
                //         {
                //           from: {
                //             id: "${cache.user.id.toString()}"
                //           }
                //         },
                //         {
                //           to : {
                //             id: "${cache.user.id.toString()}"
                //           }
                //         }
                //       ]
                //     }){
                //       id
                //       dateInit
                //       dateInitF
                //       description
                //       createdAt
                //       from {
                //         name
                //       }
                //       to {
                //         name
                //       }
                //       anuncio {
                //         skill {
                //           name
                //         }
                //       }
                //     }
                //   }`).then(
                    client.request(`
                    {
                        from: allProposes(filter: {
                            fromId: "${cache.user.id.toString()}"
                        }){
                          id
                          dateInit
                          dateInitF
                          description
                          createdAt
                          from {
                            name
                          }
                          to {
                            name
                          }
                          anuncio {
                            skill {
                              name
                            }
                          }
                        }
                        to: allProposes(filter: {
                              toId: "${cache.user.id.toString()}"
                        }){
                          id
                          dateInit
                          dateInitF
                          description
                          createdAt
                          from {
                            name
                          }
                          to {
                            name
                          }
                          anuncio {
                            skill {
                              name
                            }
                          }
                        }
                      }`).then(
                    res => {
                        ArrayEventFake = res.from.concat(res.to)
                        // let ArrayEventFake = [
                        //     { dateInit: "2019-12-01T03:00:00.000Z", titulo: 'titulo 1' },
                        //     { dateInit: "2019-12-17T03:00:00.000Z", titulo: 'titulo 2' },
                        //     { dateInit: "2019-12-18T03:00:00.000Z", titulo: 'titulo 3' },
                        //     { dateInit: "2019-12-19T03:00:00.000Z", titulo: 'titulo 4' },
                        //     { dateInit: "2019-11-19T03:00:00.000Z", titulo: 'titulo 5' },
                        // ];

                        // console.log("arrey de evento", ArrayEventFake)
                        if (ArrayEventFake && ArrayEventFake.length > 0) {
                            try {
                                ArrayEventFake.map((obj) => {
                                    let day = new Date(obj.dateInitF ? obj.dateInitF : obj.dateInit).getDate();
                                    let month = new Date(obj.dateInitF ? obj.dateInitF : obj.dateInit).getMonth();
                                    // let year = new Date(obj.dateInit).getFullYear();
                                    // date = `${day}/${month}/${year}`;
                                    // console.log(obj)

                                    if (month === currentMonth) {
                                        arrayDays.map(checkedDay => {
                                            if (checkedDay.createdAt === day) {
                                                checkedDay.hasEvent = true;
                                                checkedDay.url = '/proposedetails/' + obj.id;
                                                checkedDay.titulo = obj.anuncio ? obj.anuncio.skill.name : obj.skill;
                                                //return {hasEvent: true, url: ''}
                                            } else if (checkedDay.createdAt !== day && !checkedDay.hasEvent) {
                                                checkedDay.hasEvent = false;
                                            }

                                            return this.setState({ days: arrayDays, loading: false })
                                        })
                                    }

                                    return null
                                })
                            } catch {
                                throw new Error()
                            }
                        }
                    }
                )
            }
        };
    }

    getDays = (year, month) => {
        let currentMonth = month + 1;

        let baseDate = new Date(year, currentMonth, 0),
            firstDay = new Date(year, month, 1).getDay(),
            lastDay = baseDate.getDate(),
            nameMonth = new Date(year, month, 1).toLocaleString('pt-br', { month: 'long' }),
            allDays = [],
            day, extraDays;

        // console.log(firstDay);

        for (day = 0; day < lastDay; day++) {
            let createdDay = day + 1,
                date = { date: createdDay, selected: false, hasEvent: false };

            allDays.push(date);
        }

        for (extraDays = 0; extraDays < firstDay; extraDays++) {
            let extraDate = { date: '' };

            allDays.unshift(extraDate);
        }

        this.checkSelectedDay(allDays, new Date().getDate());


        try {
            this.addEventsDay(allDays, month);
        } catch {
            throw new Error()
        }
        this.setState({ monthName: nameMonth });
        // console.log(allDays);
        // console.log(nameMonth);
    };

    checkSelectedDay = (array, day) => {
        let list = array;

        list.map(o => {
            let today = day,
                select;

            if (o.selected) {
                select = false;
            }

            if (o.date === today) {
                select = true
            }

            return o.selected = select;
        });

        this.setState({ days: list })
    };

    backOneMonth = () => {
        let month = this.state.currentMonth,
            year = this.state.currentYear,
            nameMonth;

        if (month === 0) {
            month = 11;

            // nameMonth = new Date(2019, month+1, 0).toLocaleString('pt-br', {month: 'long'});
            this.setState({ currentMonth: month });
            return this.backOneYear(month)
        } else {
            month = month - 1
        }

        // console.log(year);

        nameMonth = new Date(2019, month + 1, 0).toLocaleString('pt-br', { month: 'long' });
        this.setState({ currentMonth: month, monthName: nameMonth });
        this.getDays(year, month)
    };

    forwardOneMonth = () => {
        let month = this.state.currentMonth
        let year = this.state.currentYear
        let nameMonth = null

        if (month === 11) {
            month = 0;

            nameMonth = new Date(2019, month + 1, 0).toLocaleString('pt-br', { month: 'long' });

            // alert(nameMonth);

            this.setState({ currentMonth: month });
            return this.forwardOneYear(month)
        } else {
            month = month + 1
        }

        // nameMonth = new Date(2019, month+1, 0).toLocaleString('pt-br', {month: 'long'});
        this.setState({ currentMonth: month });
        this.getDays(year, month)
    };

    backOneYear = (month) => {
        let currentYear = this.state.currentYear;

        currentYear = currentYear - 1;

        this.setState({ currentYear: currentYear });
        this.getDays(currentYear, month)
    };

    forwardOneYear = (month) => {
        let currentYear = this.state.currentYear;

        currentYear = currentYear + 1;

        this.setState({ currentYear: currentYear });
        this.getDays(currentYear, month)
    };

    componentDidMount() {

        try {
            this.getDays(this.state.currentYear, this.state.currentMonth);
        } catch {
            throw new Error()
        }
        // console.log(this.state.currentYear)
    }

    render() {
        return (
            <div className={'calendar'}>
                <div className={'header'}>
                    <div className={'btnArrow'} onClick={this.backOneMonth}>
                        <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
                            <path fill="#5f5f5f" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                        </svg>
                    </div>
                    <div><h4>{this.state.monthName} - {this.state.currentYear}</h4></div>
                    <div className={'btnArrow'} onClick={this.forwardOneMonth}>
                        <svg style={{ width: "24px", height: "24px" }} viewBox="0 0 24 24">
                            <path fill="#5f5f5f" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                        </svg>
                    </div>
                    {this.state.loading ? <MiniLoading /> : null}
                </div>
                <div className={'days'}>
                    <div><span>Dom</span></div>
                    <div><span>Seg</span></div>
                    <div><span>Ter</span></div>
                    <div><span>Qua</span></div>
                    <div><span>Qui</span></div>
                    <div><span>Sex</span></div>
                    <div><span>Sab</span></div>
                </div>
                <div className={'list'}>
                    {this.state.days.map((obj, i) =>
                        <Link key={i} onClick={() => this.checkSelectedDay(this.state.days, obj.date)}>
                            <div className={obj.selected ? 'active' : ''}>
                                <span>{obj.date}</span>
                                {/*EVENTO MARCADO E TOOLTIP*/}
                                {obj.hasEvent ? <div className={'event'}>
                                    <span>{obj.titulo}</span>
                                    {/* <span>{obj.anuncios.skills.name}</span> */}
                                </div> : null}
                                {/*EVENTO MARCADO E TOOLTIP*/}
                            </div>
                        </Link>
                    )}
                </div>
            </div>
        )
    }
}
